import Responsive from './Responsive';
class Gmap{
	constructor() {
		const r = new Responsive();

		this.target = 'fooer-map';
		this.styles = [{"stylers": [{ "visibility": "on" },{ "saturation": -100 },{ "lightness": 28 },{ "gamma": 0.98 }]}];
		// console.log(r.state()());
		if(r.state()() === false){
			this.center = {lat:35.01165 , lng:135.75956};
		}else{
			this.center = {lat:35.01165 , lng:135.75956};
		}

		this.pins = [{lat:35.01267 , lng:135.75989}];
		this.settings = {
			zoom:17,
			icon:{
				url : MAP_PIN,
				scaledSize : new google.maps.Size(52, 86)
				// ↑ここで画像のサイズを指定
			},
			title:'map',
		};
	}

	exec(){
		const colorName = 'thisstyle';
		const settings = this.settings;
		const MAP = document.getElementById(this.target);
		const myOptions = {
			zoom: settings.zoom,
			center : new google.maps.LatLng(this.center.lat,this.center.lng),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			streetViewControl:false,
			mapTypeControl: false,
			zoomControl: true,
			zoomControlOptions: {
				style: google.maps.ZoomControlStyle.LARGE
			},
			scrollwheel: false
		};

		const map = new google.maps.Map(MAP, myOptions);

		//デザイン設定と地図タイプの名前を反映
		map.mapTypes.set(colorName, new google.maps.StyledMapType(this.styles, { name: colorName }));
		map.setMapTypeId(colorName);

		//marker
		_.each(this.pins,function(pin){
			let marker = new google.maps.Marker();
			marker.setPosition(new google.maps.LatLng(pin.lat, pin.lng));
			marker.setIcon(settings.icon);
			marker.setTitle(settings.title);
			marker.setMap(map);
		});
	}
}
module.exports = Gmap;



// WEBPACK FOOTER //
// ./dev/js/scripts/Gmap.js